/** Accepts the spellings people actually type; everything else is an error. */
export const envFlag = (
  name: string,
  env: { [x: string]: any },
  fallback = false,
): boolean => {
  const raw = env[name];
  if (raw === undefined || raw === "") return fallback;
  const v = raw.trim().toLowerCase();
  if (["1", "true", "yes", "on"].includes(v)) return true;
  if (["0", "false", "no", "off"].includes(v)) return false;
  throw new Error(`${name} must be a boolean, got ${JSON.stringify(raw)}`);
};
